export default "__VITE_ASSET__9ade1bae__"